import {Component, OnDestroy, OnInit} from '@angular/core';
import {UnitesDeProductionService} from '../../../core/services/entities/unites-de-production.service';
import {FormFieldBaseSupplier} from '../../../core/suppliers/form-fieldbase-supplier';
import {ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs';
import {UniteDeProductionSupplier} from '../unite-production-resolver.service';
import {UtilsService} from '../../../core/utils/utils.service';
import {UniteDeProductionDTO} from '../../../core/dtos/unite-de-production-dto';
import {FormControl, FormGroup} from '@angular/forms';
import {GenericFormService} from '../../../core/services/generics/generic-form.service';
import {GenericDatagridService} from '../../../core/services/generics/generic-datagrid.service';
import {FS_ROUTES, HELP_FOLDERS, MSG_KEY, MSG_SEVERITY} from '../../../core/constants';
import {AdressesService} from '../../../core/services/entities/adresses.service';
import {RoutemapService} from '../../../core/services/routemap.service';
import {cloneDeep as _cloneDeep, find as _find} from 'lodash'
import {SiteService} from '../../../core/site.service';
import {SiteDTO} from '../../../core/dtos/site-dto';
import {DialogMsgSupplier, Paragraphe} from '../../../core/suppliers/dialog-msg-supplier';
import {ColumnsToHideDTO} from "../../../core/dtos/columns-to-hide.dto";
import {ColumnsPdfDTO} from "../../../core/dtos/columns-pdf-dto";
import {ColumnsPdfService} from "../../../core/services/columns-pdf/columns-pdf.service";
import {FormFieldFileSupplier} from "../../../core/suppliers/form-field-file-supplier";
import {DocumentService} from "../../../core/services/document.service";
import {ToastService} from "../../../core/services/technique/toast.service";
import {DateReferenteUniteDeProductionEnum} from "../../../core/enums/date-referente-unite-de-production-enum";
import {UniteDeProductionInfoFacturationDto} from "../../../core/dtos/unite-de-production/unite-de-production-info-facturation-dto";
import {DepartementDTO} from "../../../core/dtos/departement-dto";
import {GraphQLService} from "../../../core/services/technique/graphql.service";
import {ButtonThemeEnum} from '../../../shared/ui/button/button-theme-enum';
import {SecteurActiviteService} from "../../../core/services/entities/secteur-activite.service";

@Component({
    selector: 'yo-up-ficheidentite',
    templateUrl: './up-ficheidentite.component.html',
    styleUrls: ['./up-ficheidentite.component.scss'],
    standalone: false
})
export class UpFicheidentiteComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;


  subscriptionRoute: Subscription;
  subSidenav: Subscription;
  subDepartements: Subscription;

  subSite: Subscription;
  udpSite$;

  subLibelle: Subscription;
  udpLibelle$;

  fieldsInfosGenerales: FormFieldBaseSupplier<any>[];
  fieldsDivers: FormFieldBaseSupplier<any>[];
  fieldsAdresseLivraison: FormFieldBaseSupplier<any>[];
  fieldsAdresseFacturation: FormFieldBaseSupplier<any>[];

  fieldsContacts: FormFieldBaseSupplier<any>[];

  form: FormGroup;
  formInfoGenerales: FormGroup;
  formAdresseLivraison: FormGroup;
  formAdresseFacturation: FormGroup;
  formSameAddress: FormGroup;
  formDivers: FormGroup;
  formDepartements: FormGroup;
  formMarche: FormGroup;
  formColumnsBonCommandePdfSelected: FormGroup;
  formColumnsBonReceptionPdfSelected: FormGroup;
  formInfoFacturation: FormGroup;
  formSecteurActivite: FormGroup;
  estampilleVeterinaireFile: FormFieldFileSupplier;
  previewEstampilleVeterinaireFile: File;

  selectedUniteDeProduction: UniteDeProductionDTO;

  isSameAdresse: boolean = false;
  docError: boolean = false;

  ancienNomAdresseDeLivraison: string;
  ancienNomAdresseDeFacturation: string;

  columnsBonCommandePdf: ColumnsPdfDTO[] = [];
  columnsBonReceptionPdf: ColumnsPdfDTO[] = [];

  columnsBonCommandePdfSelected: ColumnsPdfDTO[] = [];
  columnsBonReceptionPdfSelected: ColumnsPdfDTO[] = [];

  pathFile: string = HELP_FOLDERS.UNITE_DE_PRODUCTION + '/edition-unites-production';

  //Onglet marché
  datesChoice: any[] = [
    {label: 'Date de livraison', value: DateReferenteUniteDeProductionEnum.DATE_LIVRAISON},
    {label: 'Date de commande', value: DateReferenteUniteDeProductionEnum.DATE_COMMANDE}
  ];

  selectedDepartements: number[] = [];
  departementList: DepartementDTO[];
  departementListEnriched: any[] = [];

  constructor(public udpSvc: UnitesDeProductionService,
              public adressesSvc: AdressesService,
              private route: ActivatedRoute,
              private routeMapSvc: RoutemapService,
              private gfs: GenericFormService,
              public gds: GenericDatagridService,
              public utils: UtilsService,
              private siteService: SiteService,
              private columnsPdfSvc: ColumnsPdfService,
              private documentSvc: DocumentService,
              private toastSvc: ToastService,
              private graphQlSvc: GraphQLService,
              public secteurActiviteSvc: SecteurActiviteService) {
  }

  ngOnInit() {
    this.initEmptyFormAndData();
    this.initData();
    this.initEstampilleVeterinaire();
  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subscriptionRoute);
    this.utils.unsubscribe(this.subSidenav);
    this.utils.unsubscribe(this.subSite);
    this.utils.unsubscribe(this.subDepartements);
  }

  initEstampilleVeterinaire = (): void => {
    this.estampilleVeterinaireFile = new FormFieldFileSupplier({
      key: 'file',
      label: 'Estampille vétérinaire',
      value: '',
      entityName: `${this.udpSvc.getEntityName().toLowerCase()}-estampilleVeterinaire`,
      required: false,
      refresh: new Date().getTime(),
      ordre: 1
    });
  };

  previewImage = (): void => {
    const reader = new FileReader();
    reader.onload = function (e: any) {
      document.getElementById('previewEstampilleVeterinaireFile').setAttribute('src', e.target.result);
    }
    reader.readAsDataURL(this.previewEstampilleVeterinaireFile);
  };

  onFileChange = (event: any) => {
    if (event.target.files && event.target.files.length) {
      this.previewEstampilleVeterinaireFile = event.target.files[0];
      if (!this.utils.isNullOrEmpty(this.previewEstampilleVeterinaireFile)) {
        this.previewImage();
      }
    }
  };

  initEmptyFormAndData = () => {
    this.adressesSvc.siteReadOnly = true;

    this.form = new FormGroup({});
    this.formInfoGenerales = new FormGroup({});
    this.formAdresseLivraison = new FormGroup({});
    this.formAdresseFacturation = new FormGroup({});
    this.formSameAddress = new FormGroup({sameAddress: new FormControl(true)});
    this.formDivers = new FormGroup({});
    this.formDepartements = new FormGroup({departements: new FormControl(this.selectedUniteDeProduction?.departements)});
    this.formMarche = new FormGroup({dateReferente: new FormControl(DateReferenteUniteDeProductionEnum.DATE_LIVRAISON)});
    this.formColumnsBonCommandePdfSelected = new FormGroup({
      columnsBonCommandePdfSelected: new FormControl([]),
      hideFinancialData: new FormControl(false)
    });
    this.formColumnsBonReceptionPdfSelected = new FormGroup({
      columnsBonReceptionPdfSelected: new FormControl([])
    });
    this.formInfoFacturation = new FormGroup({
      formeJuridiqueCapital: new FormControl(),
      siret: new FormControl(),
      codeApe: new FormControl(),
      iban: new FormControl(),
      bic: new FormControl(),
      vatid: new FormControl(),
      codeAnalytique: new FormControl(),
      referenceInterne: new FormControl(),
      referenceInterneComptabilite: new FormControl()
    });
    this.formSecteurActivite = new FormGroup({
      secteurActivite: new FormControl()
    });
  };

  /**
   * Initialiser les formulaires infos générales, adresse livraison, adresse facturation  avec l'unite de production
   */
  initForm = (uniteDeProduction: UniteDeProductionDTO) => {

    this.siteService.findSitesLocauxSansUniteDeProductionByUser().subscribe(data => {
      // Création d'une Unité de production
      if (uniteDeProduction.id == 0) {
        this.fieldsInfosGenerales = this.udpSvc.getFieldsAvecSitesSansUniteDeProduction(uniteDeProduction, data);
        // Modification d'une Unité de production
      } else {
        this.fieldsInfosGenerales = this.udpSvc.getFields(uniteDeProduction);
      }
      this.ancienNomAdresseDeFacturation = this.selectedUniteDeProduction.adresseFacturation.nom;
      this.ancienNomAdresseDeLivraison = this.selectedUniteDeProduction.adresseLivraison.nom;

      let isSameAddress = this.adressesSvc.isSameAddress(this.selectedUniteDeProduction.adresseFacturation, this.selectedUniteDeProduction.adresseLivraison);
      this.isSameAdresse = isSameAddress;

      this.fieldsDivers = this.udpSvc.getFieldsDivers(this.selectedUniteDeProduction);

      this.fieldsAdresseLivraison = this.adressesSvc.getFields(uniteDeProduction.adresseLivraison);
      this.fieldsAdresseFacturation = this.adressesSvc.getFields(uniteDeProduction.adresseFacturation);

      this.formInfoGenerales = this.gfs.toFormGroup(this.fieldsInfosGenerales);
      this.formAdresseLivraison = this.gfs.toFormGroup(this.fieldsAdresseLivraison);
      this.formAdresseFacturation = this.gfs.toFormGroup(this.fieldsAdresseFacturation);
      this.formSameAddress = new FormGroup({sameAddress: new FormControl(isSameAddress)});
      this.formDivers = this.gfs.toFormGroup(this.fieldsDivers);

      this.columnsBonCommandePdfSelected =
        this.columnsBonCommandePdf.filter(c => uniteDeProduction.columnsToHideList.filter(c => c.typeColumnsToHide.code === 'BON_COMMANDES').findIndex((cc: ColumnsToHideDTO) => cc.columnPdf.id === c.id) > -1);

      const selectedColumnsBonReceptionPdf: ColumnsPdfDTO[] = uniteDeProduction.columnsToHideList.filter(c => c.typeColumnsToHide.code === 'BON_RECEPTION').map(c => c.columnPdf);
      this.columnsBonReceptionPdfSelected =
        this.columnsBonCommandePdf.filter(c => selectedColumnsBonReceptionPdf.some(sc => sc.id === c.id));

      this.formColumnsBonCommandePdfSelected = new FormGroup({
        hideFinancialData: new FormControl(uniteDeProduction.hideFinancialDataCommands),
        columnsBonCommandePdfSelected: new FormControl(this.columnsBonCommandePdfSelected)
      });

      this.formColumnsBonReceptionPdfSelected = new FormGroup({
        columnsBonReceptionPdfSelected: new FormControl(this.columnsBonReceptionPdfSelected)
      });

      this.formDepartements = new FormGroup({
        departements: new FormControl(this.selectedDepartements)});

      this.formMarche = new FormGroup({
        dateReferente: new FormControl(this.selectedUniteDeProduction.dateReferente)
      });


      this.formInfoFacturation = new FormGroup({
        formeJuridiqueCapital: new FormControl(this.selectedUniteDeProduction.uniteDeProduction_infoFacturation?.formeJuridiqueCapital),
        siret: new FormControl(this.selectedUniteDeProduction.uniteDeProduction_infoFacturation?.siret),
        codeApe: new FormControl(this.selectedUniteDeProduction.uniteDeProduction_infoFacturation?.codeApe),
        iban: new FormControl(this.selectedUniteDeProduction.uniteDeProduction_infoFacturation?.iban),
        bic: new FormControl(this.selectedUniteDeProduction.uniteDeProduction_infoFacturation?.bic),
        vatid: new FormControl(this.selectedUniteDeProduction.uniteDeProduction_infoFacturation?.vatid),
        codeAnalytique: new FormControl(this.selectedUniteDeProduction.uniteDeProduction_infoFacturation?.codeAnalytique),
        referenceInterne: new FormControl(this.selectedUniteDeProduction.uniteDeProduction_infoFacturation?.referenceInterne),
        referenceInterneComptabilite: new FormControl(this.selectedUniteDeProduction.uniteDeProduction_infoFacturation?.referenceInterneComptabilite)
      });

      this.formSecteurActivite = new FormGroup({
        secteurActivite: new FormControl(this.selectedUniteDeProduction.secteurActivite?.id ?? null)
      });


      this.form = new FormGroup({
        formInfoGenerales: this.formInfoGenerales,
        formAdresseLivraison: this.formAdresseLivraison,
        formAdresseFacturation: this.formAdresseFacturation,
        formSameAddress: this.formSameAddress,
        formDivers: this.formDivers,
        formMarche: this.formMarche,
        formDepartements: this.formDepartements,
        formColumnsBonCommandePdfSelected: this.formColumnsBonCommandePdfSelected,
        formColumnsBonReceptionPdfSelected: this.formColumnsBonReceptionPdfSelected,
        formInfoFacturation: this.formInfoFacturation,
        formSecteurActivite: this.formSecteurActivite,
      });

      this.manageAdresseFacturationForm(isSameAddress);
      this.initDepartements();
    });
  };

  initData = () => {

    //abonnement à l'annonce de l'ouverture du sidenav, cas où le router n'est pas reloadé, on veut quand meme reinit
    this.subSidenav = this.routeMapSvc.sidenav$.subscribe(sidenav => {
      //on reinitialise les formgroups
      this.initForm(this.selectedUniteDeProduction);
    });

    this.columnsPdfSvc.getAll()
      .subscribe(response => {
        this.columnsBonCommandePdf = response.resultList;
        this.columnsBonReceptionPdf = response.resultList.filter(c => c.code === 'CODE_DENREE');
        this.initRouteSubscription();
      });

    this.udpSite$ = this.udpSvc.site$;

    this.subSite = this.udpSite$.subscribe(value => {
      this.selectedUniteDeProduction.site = value;
      if (!this.utils.isCollectionNullOrEmpty(this.fieldsAdresseLivraison)) {
        const field = _find(this.fieldsAdresseLivraison, {'key': 'site'});
        this.formAdresseLivraison.controls[field.key].setValue(value);
      }
      if (!this.utils.isCollectionNullOrEmpty(this.fieldsAdresseFacturation)) {
        const field = _find(this.fieldsAdresseLivraison, {'key': 'site'});
        this.formAdresseFacturation.controls[field.key].setValue(value);
      }

    });

    this.udpLibelle$ = this.udpSvc.libelle$;
    this.subLibelle = this.udpLibelle$.subscribe(value => {
      if (!this.utils.isCollectionNullOrEmpty(this.fieldsAdresseLivraison)) {
        const field = _find(this.fieldsAdresseLivraison, {'key': 'nom'});
        if (UtilsService.staticIsNullOrEmpty(this.ancienNomAdresseDeLivraison)) {
          this.formAdresseLivraison.controls[field.key].setValue(value);
        }

      }
      if (!this.utils.isCollectionNullOrEmpty(this.fieldsAdresseFacturation)) {
        const field = _find(this.fieldsAdresseLivraison, {'key': 'nom'});
        if (UtilsService.staticIsNullOrEmpty(this.ancienNomAdresseDeFacturation)) {
          this.formAdresseFacturation.controls[field.key].setValue(value);
        }
      }


    });

  };

  initRouteSubscription = () => {
    this.subscriptionRoute = this.route.parent.data
      .subscribe((data: { uniteDeProductionSupplier: UniteDeProductionSupplier }) => {
        this.selectedUniteDeProduction = data.uniteDeProductionSupplier.uniteDeProduction;
        this.initForm(this.selectedUniteDeProduction);

        this.udpSvc.checkEstampilleVeterinaire(this.selectedUniteDeProduction.id)
          .subscribe(r => this.selectedUniteDeProduction.hasEstampilleVeterinaire = r.one);

      });
  }

  onChangeSameAddress = event => {
    this.isSameAdresse = event.checked;
    this.manageAdresseFacturationForm(event);
  };

  deleteFile = (field: any) => {
    const entityId = this.selectedUniteDeProduction.id;
    this.documentSvc.removeByEntity(field.entityName, entityId, field.ordre).subscribe(response => {
      // rafraichir l'image ou le document
      field.refresh = new Date().getTime();
      this.udpSvc.checkEstampilleVeterinaire(this.selectedUniteDeProduction.id)
        .subscribe(r => this.selectedUniteDeProduction.hasEstampilleVeterinaire = r.one); // refresh ne fct pas
    });
  };

  initDepartements = () => {
    this.subDepartements = this.graphQlSvc.sendQuery(`
      {
        allDepartement {
          id,
          code,
          nom,
          region {
            id,
            code,
            nom
          }
        }
      }
    `).subscribe(item => {
      this.departementList = item.allDepartement;
      this.departementListEnriched = [...this.departementList]
        .sort((a, b) => a.code.localeCompare(b.code))
        .map(dep => ({...dep, regionNom: dep.region?.nom, regionCode: dep.region?.code, nom: `${dep.code} - ${dep.nom}`}));
      this.selectedDepartements = this.departementList.filter(dep =>
        this.selectedUniteDeProduction.departements.find(dep2 => dep2.id == dep.id)).map(dep => dep.id);
    });
  }

  saveFicheIdentite = () => {

    //Afficher les erreurs de validation
    this.gfs.validateAllFormFields(this.form);

    //On enregsitre que si le formulaire est valide
    if (this.form.valid) {

      this.selectedUniteDeProduction.libelle = this.formInfoGenerales.controls['libelle'].value;
      this.selectedUniteDeProduction.code = this.formInfoGenerales.controls['code'].value;
      this.selectedUniteDeProduction.actif = this.formInfoGenerales.controls['actif'].value;

      this.selectedUniteDeProduction.adresseLivraison = this.adressesSvc.prepareAdresseForSave(this.formAdresseLivraison, this.udpSvc.getEntityName());
      if (this.formSameAddress.controls['sameAddress'].value) {
        this.selectedUniteDeProduction.adresseFacturation = _cloneDeep(this.selectedUniteDeProduction.adresseLivraison);
        this.selectedUniteDeProduction.adresseFacturation.id = this.formAdresseFacturation.get('id').value;
      } else {
        this.selectedUniteDeProduction.adresseFacturation = this.adressesSvc.prepareAdresseForSave(this.formAdresseFacturation, this.udpSvc.getEntityName());
      }

      this.selectedUniteDeProduction.infosLivraison = this.formDivers.controls['infosLivraison'].value;
      this.selectedUniteDeProduction.infosFacturation = this.formDivers.controls['infosFacturation'].value;
      this.selectedUniteDeProduction.signature = this.formDivers.controls['signature'].value;
      this.selectedUniteDeProduction.egalimThresholdBio = this.formDivers.controls['egalimThresholdBio'].value;
      this.selectedUniteDeProduction.egalimThresholdSustainableProducts = this.formDivers.controls['egalimThresholdSustainableProducts'].value;
      this.selectedUniteDeProduction.egalimThresholdPoissonViandeDurable = this.formDivers.controls['egalimThresholdPoissonViandeDurable'].value;

      const photo = this.formInfoGenerales.value.file;
      const estampilleVeterinaire = this.previewEstampilleVeterinaireFile;

      const columns = this.formColumnsBonCommandePdfSelected.controls['columnsBonCommandePdfSelected'].value;

      const columnsBonReception = this.formColumnsBonReceptionPdfSelected.controls['columnsBonReceptionPdfSelected'].value;

      const columnsToHideList: ColumnsToHideDTO[] = columns.map((col: ColumnsPdfDTO) => {
        return ({code: col.code, idUdp: this.selectedUniteDeProduction.id, columnPdf: col});
      });

      const columnsBonReceptionToHideList: ColumnsToHideDTO[] = columnsBonReception.map((col: ColumnsPdfDTO) => {
        return ({code: col.code, idUdp: this.selectedUniteDeProduction.id, columnPdf: col});
      });

      this.selectedUniteDeProduction.columnsBonReceptionToHideList = columnsBonReceptionToHideList;
      this.selectedUniteDeProduction.columnsToHideList = columnsToHideList;
      this.selectedUniteDeProduction.hideFinancialDataCommands = this.formColumnsBonCommandePdfSelected.controls['hideFinancialData'].value;

      this.selectedUniteDeProduction.dateReferente = this.formMarche.controls['dateReferente'].value;

      const secteurActiviteId = this.formSecteurActivite.controls['secteurActivite'].value;
      this.selectedUniteDeProduction.secteurActivite = secteurActiviteId
        ? (this.secteurActiviteSvc.secteursActiviteResource.value() ?? []).find(s => s.id === secteurActiviteId) ?? null
        : null;

      this.selectedUniteDeProduction.uniteDeProduction_infoFacturation = this.prepareInfoFacturationForSave();

      this.udpSvc.saveFicheIdentite(this.selectedUniteDeProduction, photo, estampilleVeterinaire).subscribe(response => {

        if (!this.utils.isResponseSupplierError(response)) {
          //annoncer que la fiche d'identite a été sauvegardée. La grille des unites de prod doit être abonnée pour faire la mise à jour
          this.udpSvc.announceSavedDTO(response);
          this.selectedUniteDeProduction = response.one;
          this.initForm(this.selectedUniteDeProduction);
          this.routeMapSvc.goToSecondaryRoute([FS_ROUTES.GUP_UPRO, this.selectedUniteDeProduction.id, 'ficheidentite']);
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Enregistrement de l'unité de production ${this.selectedUniteDeProduction.libelle.toUpperCase()} réalisé avec succès`);

          this.udpSvc.checkEstampilleVeterinaire(this.selectedUniteDeProduction.id)
            .subscribe(r => this.selectedUniteDeProduction.hasEstampilleVeterinaire = r.one);
          if (this.selectedUniteDeProduction.columnsToHideList && this.selectedUniteDeProduction.columnsToHideList.length) {
            this.columnsBonCommandePdfSelected =
              this.columnsBonCommandePdf.filter(c => this.selectedUniteDeProduction.columnsToHideList.findIndex((cc: ColumnsToHideDTO) => cc.columnPdf.id === c.id) > -1);
          } else {
            this.columnsBonCommandePdfSelected = [];
          }
        }
      });

    }
  };


  /**
   * Activer ou pas le formulaire d'adresse facturation
   * @param {boolean} sameAddress
   */
  private manageAdresseFacturationForm = (sameAddress: boolean) => {
    if (sameAddress) {
      this.form.removeControl('formAdresseFacturation');
    } else {
      this.form.addControl('formAdresseFacturation', this.formAdresseFacturation);
    }
  };

  prepareInfoFacturationForSave() {
    let udpInfoFactuToSave = _cloneDeep(this.selectedUniteDeProduction?.uniteDeProduction_infoFacturation);
    if (!udpInfoFactuToSave) {
      udpInfoFactuToSave = new UniteDeProductionInfoFacturationDto();
    }
    udpInfoFactuToSave.siret = this.formInfoFacturation.controls['siret'].value;
    udpInfoFactuToSave.codeApe = this.formInfoFacturation.controls['codeApe'].value;
    udpInfoFactuToSave.iban = this.formInfoFacturation.controls['iban'].value;
    udpInfoFactuToSave.formeJuridiqueCapital = this.formInfoFacturation.controls['formeJuridiqueCapital'].value;
    udpInfoFactuToSave.bic = this.formInfoFacturation.controls['bic'].value;
    udpInfoFactuToSave.vatid = this.formInfoFacturation.controls['vatid'].value;
    udpInfoFactuToSave.codeAnalytique = this.formInfoFacturation.controls['codeAnalytique'].value;
    udpInfoFactuToSave.referenceInterne = this.formInfoFacturation.controls['referenceInterne'].value;
    udpInfoFactuToSave.referenceInterneComptabilite = this.formInfoFacturation.controls['referenceInterneComptabilite'].value;
    const isEmpty = (!udpInfoFactuToSave.siret && !udpInfoFactuToSave.codeApe && !udpInfoFactuToSave.iban && !udpInfoFactuToSave.formeJuridiqueCapital && !udpInfoFactuToSave.bic && !udpInfoFactuToSave.vatid && !udpInfoFactuToSave.codeAnalytique && !udpInfoFactuToSave.referenceInterne && !udpInfoFactuToSave.referenceInterneComptabilite)
    return isEmpty ? null : udpInfoFactuToSave;
  }

  groupDepartementByRegion = (dep: DepartementDTO): string => dep.region.nom;

  onDepartementsChange = (selectedIds: number[]): void => {
    this.selectedDepartements = selectedIds.length ? selectedIds : null;
    this.selectedUniteDeProduction.departements = selectedIds.length
      ? this.departementList.filter(dep => selectedIds.find(id => id === dep.id))
      : null;
  };

  getHelp = (): DialogMsgSupplier => {
    let dms = new DialogMsgSupplier();
    dms.title = `Fiche d'identité d'une unité de production.`;

    let p1: Paragraphe = new Paragraphe();
    let p2: Paragraphe = new Paragraphe();
    let p3: Paragraphe = new Paragraphe();
    p1.title = `Une unité de production (UP) est un lieu de fabrication auquel un site est rattaché.`;
    p2.title = `Cette UP porte donc tous les paramètres administratifs et fonctionnels nécessaires à l'activité d'un site de production.`;
    p3.title = `Les données administratives à renseigner permettent de déterminer l'identité et les coordonnées d'une UP.`;

    dms.content = {
      intro: ``,
      paragraphes: [p1, p2, p3]

    };

    return dms;
  };
}
